import React from "react";
import PropTypes from "prop-types";

import { Icon } from "rhombus-react";

import "./EmptySection.css";

export default function EmptySection(props){
	let $img = null;

	if(props.src){
		$img = <img src={props.src} className={"image"} alt="Empty Image" />;
	} else if(props.icon){
		$img = <Icon name={props.icon} className="item-icon" />;
	}

	return (
		<section className={`${props.className} empty-section flex-center`}>
			{$img}
			<h4  className={"header"}>{props.header}</h4>
			{props.message && <p className={"message"}>{props.message}</p>}
			<div className={"buttons"}>{props.buttons}</div>
		</section>
	);
}

EmptySection.defaultProps = {
	className:"",
};

EmptySection.propTypes = {
	className:PropTypes.string,
	src:PropTypes.string,
	icon:PropTypes.string,
	header:PropTypes.string.isRequired,
	message:PropTypes.string,
	buttons:PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element)
	]),
};
